module.exports = __webpack_public_path__ + "img/img18.5eb81b99.png";